import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { PopOut } from "@gaming/xds-react-js-icons";

// Leaf imports, not the `clarity` barrel — see the note in useLandingCta.ts.
import { trackClarityEvent } from "../../../../clarity/clarityClient";
import { ClarityEvents } from "../../../../clarity/clarityEvents";
import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useStrings } from "../../../../localization/localizationHelpers";

import * as styles from "./PartnerCommunitySection.module.css";

const githubIcon = getImage("icon_github", ImageType.Png);
const discordIcon = getImage("icon_discord", ImageType.Png);

const githubUrl = "https://github.com/microsoft/GDK";
const discordUrl = "https://aka.ms/msftgamedevdiscord";

export const PartnerCommunitySection = () => {
  const [
    sectionTitle,
    subtitle,
    githubTitle,
    githubDescription,
    githubLink,
    githubIconAlt,
    githubLinkAria,
    discordTitle,
    discordDescription,
    discordLink,
    discordIconAlt,
    discordLinkAria,
  ] = useStrings(
    "landingCommunityTitle",
    "landingCommunitySubtitle",
    "landingCommunityGithubTitle",
    "landingCommunityGithubDescription",
    "landingCommunityGithubLink",
    "landingCommunityGithubIconAlt",
    "landingCommunityGithubLinkAria",
    "landingCommunityDiscordTitle",
    "landingCommunityDiscordDescription",
    "landingCommunityDiscordLink",
    "landingCommunityDiscordIconAlt",
    "landingCommunityDiscordLinkAria"
  );

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{sectionTitle}</h2>
      <p className={styles.subtitle}>{subtitle}</p>
      <div className={styles.cardGrid}>
        <div className={styles.card}>
          <img className={styles.icon} src={githubIcon} alt={githubIconAlt} />
          <div className={styles.cardBody}>
            <span className={styles.cardTitle}>{githubTitle}</span>
            <span className={styles.cardDescription}>{githubDescription}</span>
          </div>
          <a
            className={styles.cardLink}
            href={githubUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={githubLinkAria}
            onClick={() => trackClarityEvent(ClarityEvents.landingGithubClicked)}
          >
            {githubLink}
            <Icon icon={PopOut} iconSize={IconSize.Small} />
          </a>
        </div>
        <div className={styles.card}>
          <img className={styles.icon} src={discordIcon} alt={discordIconAlt} />
          <div className={styles.cardBody}>
            <span className={styles.cardTitle}>{discordTitle}</span>
            <span className={styles.cardDescription}>{discordDescription}</span>
          </div>
          <a
            className={styles.cardLink}
            href={discordUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={discordLinkAria}
            onClick={() => trackClarityEvent(ClarityEvents.landingDiscordClicked)}
          >
            {discordLink}
            <Icon icon={PopOut} iconSize={IconSize.Small} />
          </a>
        </div>
      </div>
    </section>
  );
};
